export default class AuthenticationForm {
  constructor(authenticationType) {
    this.authenticationType = authenticationType
  }

  init() {
    this.updateAuthenticationFormFieldsRequirement()

    document
      .querySelectorAll("input[type=radio][name='partners_service[authentication_type]']")
      .forEach(input => (input.onchange = this.updateAuthMethod.bind(this)))

    document.querySelector(
      "form.service-edit-authentication"
    ).onsubmit = this.validateForm.bind(this)
  }

  updateAuthenticationFormFieldsRequirement() {
    document.querySelectorAll("[data-required-if-visible]").forEach(elem => {
      // jQuery.visible is a jQuery extension and could not cannot take advantage of querySelectorAll.
      // Using same logic from https://github.com/jquery/jquery/blob/b2bbaa36d4d37bd48f954ed3cdbd50d3461a523d/src/css/hiddenVisibleSelectors.js
      const visible =
        elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length

      visible
        ? elem.setAttribute("required", "required")
        : elem.removeAttribute("required")
    })
  }

  updateAuthMethod(elem) {
    if (elem.target.value === "api_token_auth") {
      document.querySelector(".oauth-fields").style.display = "none"
      document.querySelector(".api-token-auth-fields").style.display = "block"
    } else if (elem.target.value === "auth_not_required") {
      document.querySelector(".oauth-fields").style.display = "none"
      document.querySelector(".api-token-auth-fields").style.display = "none"
    } else {
      document.querySelector(".oauth-fields").style.display = "block"
      document.querySelector(".api-token-auth-fields").style.display = "none"
    }

    this.updateAuthenticationFormFieldsRequirement()
  }

  validateForm(event) {
    const newAuthType = document.querySelector("input[type=radio]:checked").value

    if (this.authenticationType === newAuthType) return true

    const confirm = window.confirm(this.confirmationDialogMessage(newAuthType))

    if (confirm) {
      return true
    } else {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }

  // confirmationDialogMessage just run when scheme changed
  confirmationDialogMessage(newAuthType) {
    let warningMessage = ""
    const bullets = []

    if (this.authenticationType === "auth_not_required") {
      warningMessage =
        "By changing your service from non-authenticated to authenticated:"
    } else if (newAuthType === "auth_not_required") {
      warningMessage = "By disabling authentication:"
    } else if (
      ["oauth", "oauth_pkce"].includes(this.authenticationType) &&
      ["oauth_refresh_token", "oauth_pkce_refresh_token"].includes(newAuthType)
    ) {
      warningMessage = "By enabling refresh token support:"
    } else if (
      ["oauth_refresh_token", "oauth_pkce_refresh_token"].includes(this.authenticationType) &&
      ["oauth", "oauth_pkce"].includes(newAuthType)
    ) {
      warningMessage = "By disabling refresh token support:"
    } else if (newAuthType === "api_token_auth") {
      warningMessage = "By enabling API token authentication:"
    }

    if (this.authenticationType === "oauth" || this.authenticationType === "oauth_pkce") {
      bullets.push("Users' access tokens will be removed.")
    } else if (this.authenticationType === "oauth_refresh_token" || this.authenticationType === "oauth_pkce_refresh_token") {
      bullets.push("Users' access and refresh tokens will be removed.")
    }

    bullets.push("Users will need to re-activate the service.")
    bullets.push("All existing Applets for your service will be deleted.")

    return [
      warningMessage,
      bullets.map(b => "• " + b).join("\n"),
      "Do you wish to proceed with the authentication changes?",
    ].join("\n\n")
  }
}
